import React, { useState, useEffect, useRef } from 'react'
import {
  TimeInputContainer,
  TimeLabel,
  TimeInputBox,
  ClockIcon,
  TimeDropdown,
  TimeColumn,
  TimeOption,
  TimeInputProps
} from './style'
import { IoMdTime } from 'react-icons/io'
import moment from 'moment'

export const TimeInput = ({
  label,
  value = 0,
  onChange,
  disabled = false,
  invalid = false
}: TimeInputProps) => {
  const [showDropdown, setShowDropdown] = useState(false)
  const [inputValue, setInputValue] = useState('00:00')
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const formatted = moment({ hour: value }).format('HH:00')
    setInputValue(formatted)
  }, [value])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace(/[^0-9]/g, '')
    let hour = parseInt(rawValue.slice(0, 2), 10)

    if (isNaN(hour)) {
      setInputValue('00:00')
      onChange(0)
      return
    }

    hour = Math.min(23, Math.max(0, hour))

    const formatted = moment({ hour }).format('HH:00')
    setInputValue(formatted)
    onChange(hour)
  }

  const handleSelect = (hour: string) => {
    const numericValue = parseInt(hour, 10)
    onChange(numericValue)
    setShowDropdown(false)
  }

  return (
    <TimeInputContainer ref={containerRef}>
      <TimeLabel>{label}</TimeLabel>
      <TimeInputBox
        disabled={disabled}
        invalid={invalid}
        onClick={() => !disabled && setShowDropdown(true)}
      >
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          placeholder="00:00"
          disabled={disabled}
        />
        <ClockIcon>
          <IoMdTime />
        </ClockIcon>
      </TimeInputBox>

      {showDropdown && !disabled && (
        <TimeDropdown>
          <TimeColumn>
            {Array.from({ length: 24 }, (_, i) => {
              const hour = String(i).padStart(2, '0')
              return (
                <TimeOption
                  key={hour}
                  onClick={() => handleSelect(hour)}
                  selected={`${hour}:00` === inputValue}
                >
                  {`${hour}:00`}
                </TimeOption>
              )
            })}
          </TimeColumn>
        </TimeDropdown>
      )}
    </TimeInputContainer>
  )
}
